import styled from 'styled-components';
import { Container } from '../../../src/components/Grid';
import { media } from '../../styles/media';

export const Root = styled.div`
  height: 100%;
  position: relative;
  z-index: 0;
`;

export const ControlContainer = styled(Container)`
  ${media.tablet`
    z-index: 20;
  `};
`;

export const MapContainer = styled.div`
  position: relative;
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 630px;
`;

export const DetailContainer = styled.div`
  position: absolute;
  top: -60px;
  width: 100%;
  height: calc(100% + 60px);
  overflow: hidden;

  ${media.tablet`
    top: 0;
    height: 100%;
  `};
`;

export const ItineraryContainer = styled.div`
  position: relative;
  padding: ${props => props.theme.layout.gutter}px
    ${props => props.theme.layout.gutter * 2}px;
  margin: 0 auto;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);
  z-index: 10;

  ${media.desktop`
    padding: ${props => props.theme.layout.gutter * 2}px 0;
  `};
`;
